import React, { Component, Fragment } from 'react'
import ReactPixel from 'react-facebook-pixel'
import Cookies from 'universal-cookie'
import moment from 'moment'
import Helmet from 'react-helmet'
import { withRouter } from 'react-router-dom'
import { config } from '../../config.js'
import {
  Avatar,
  Box,
  Button,
  CardMedia,
  Dialog,
  DialogTitle,
  DialogContent,
  Chip,
  Grid,
  Hidden,
  Icon,
  IconButton,
  Menu,
  MenuItem,
  ListItemText,
  Paper,
  Tab,
  Tabs,
  TextField,
  Typography,
} from '@material-ui/core'
import { AvatarGroup, Alert, AlertTitle, Skeleton } from '@material-ui/lab';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth'
import { withStyles } from '@material-ui/core/styles'
import { startCase, kebabCase } from 'lodash'
import Trip from '../Trip.js'
import InfiniteScroll from 'react-infinite-scroll-component'
import SearchPanel from '../../components/SearchPanel.js'
import AppTopBar from '../../components/AppTopBar.js'
import DestinationList from '../../components/lists/DestinationList.js'
import ListFilter from '../../components/filters/ListFilter.js'
import SliderFilter from '../../components/filters/SliderFilter.js'
import ButtonFilter from '../../components/filters/ButtonFilter.js'
import { CUISINES, THINGS_TO_DO, DISTANCE, OCCASIONS, INTERESTS, TRAVEL_RESTRICTIONS,  } from '../../utils/lists.js'
import TripItinerary from '../../components/trip/TripItinerary.js'
import TripBookingBar from '../../components/trip/TripBookingBar.js'


const cookies = new Cookies();
const API = config.api.TRAVEL_URL
let abortController = new AbortController()

const CustomTab = ({ className, children }) => {
  return <Box component="div" className={className} children={children} />;
};

const ThumbComponent = (props) => {
  return (
    <span {...props}>
       👍
    </span>
  );
}

class Plan extends Component {
  constructor(props) {
    super(props)

    this.state = {
      occasion: props.location.state ? props.location.state.occasion : null,
      assistance: null,
      status: props.location.state ? props.location.state.status : null,
      id: props.travel_plan_id,
      member_id: null,
      members: props.location.state && props.location.state.members ? props.location.state.members : [],
      trips: [],
      payment: null,
      is_refunded: false,
      is_organizer: null,
      is_member: null,

      plan: {
        is_organizer: null,
        is_member: null,
        member_id: null,
        members: props.location.state && props.location.state.members ? props.location.state.members : [],
      },

      isLoading: true,
      hasMore: true,
      page: 0,
      destination_groups: [],
      filterDefaults: {
        saved: [],
        things_to_do: [],
        budget: 4000,
        weather: [-20, 40],
        distance: [],
      },
      filters: {
        saved: [],
        things_to_do: [],
      },
      search_params: {
        travelers: {
          adults: 1,
          children: 0,
          infants: 0,
        },
        dates: {
          dates_type: 'cheapest',
          start_date: null,
          end_date: null,
          nights: [2, 10],
        },
        from: null,
        to: null,
        budget: null,
        currency: null
      },

      selectedDestinations: [],

      signinDialogOpened: false,
      showInvitationLink: false,

      showFilters: false,
      showFiltersCount: 0,
      isMenuOpened: false,
      anchorEl: null,

      isSubmitting: false,
    }
  }

  componentDidMount() {
    if (!this.props.user.is_registered) {
      cookies.set('redirectTo', `/plan/${this.props.travel_plan_id}`, {
        path: '/',
        domain: config.api.DOMAIN,
        expires: new Date(Date.now() + 2 * (60 * 60 * 1000) ),
      })
    } else {
      cookies.remove('redirectTo', { path: '/', domain: config.api.DOMAIN });
    }

    if (this.props.travel_plan_id) {
      this.getPlan()
    }
    // this.getDestinations()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user.is_registered !== this.props.user.is_registered) {
      if (this.props.travel_plan_id) {
        this.getPlan()
      }
    }
  }

  handleMenuClose = (event) => {
    this.setState({isMenuOpened: false, anchorEl: null})
  }

  handleMenuOpen = (event) => {
    this.setState({isMenuOpened: true, anchorEl: event.currentTarget})
  }

  handleLeaveTrip = () => {
    const user_jwt_token = cookies.get('jwt')

    if (this.props.user.is_registered && user_jwt_token !== undefined) {
      fetch(config.api.TRAVEL_URL + '/travel_plans/' + this.state.id + '/leave', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user_jwt_token}`,
        },
        dataType: 'json',
      })
      .then(response => response.json())
      .then(data => {
        this.props.history.push('/trips')
      })
    }
  }

  updatePlan = (data, callback = null) => {
    this.setState({
      occasion: data.occasion ? data.occasion : this.state.occasion,
      assistance: data.assistance ? data.assistance : this.state.assistance,
      status: data.status ? data.status : this.state.status,
      members: data.members ? data.members : this.state.members,
      is_organizer: data.is_organizer ? data.is_organizer : this.state.is_organizer,
      is_member: data.is_member ? data.is_member : this.state.is_member,
      is_refunded: data.is_refunded ? data.is_refunded : this.state.is_refunded,
      member_id: data.member_id ? data.member_id : this.state.member_id,
      payment: data.payment ? data.payment : this.state.payment,
      search_params: data.search_params ? data.search_params : this.state.search_params,
      trips: data.trips ? data.trips : this.state.trips,
      plan: {
        members: data.members ? data.members : this.state.members,
        member_id: data.member_id ? data.member_id : this.state.member_id,
        is_organizer: data.is_organizer ? data.is_organizer : this.state.is_organizer,
        is_member: data.is_member ? data.is_member : this.state.is_member,
      },
      isLoading: false,
    }, callback)
  }

  getPlan = () => {
    const query = new URLSearchParams(window.location.search);
    let payment_completed = null

    if (query.get("success")) {
      window.gtag('event', 'purchase', {value: 4.99, currency: 'USD'})
      ReactPixel.track('Purchase', {value: 4.99, currency: 'USD'})

      payment_completed = 'success=true'
      this.props.history.push('/trips')
      this.props.history.push(this.props.location.pathname)
    }

    // abort previous fetch
    // abortController.abort()
    // abortController = new AbortController();
    // const signal = abortController.signal

    fetch(API + `/travel_plans/${this.props.travel_plan_id}` + `${payment_completed ? '?' + payment_completed : '' }`,
    {
      headers: {
        'Authorization': `Bearer ${cookies.get('jwt')}`,
      },
      // signal: signal
    })
    .then(response => response.json())
    .then(data => {
      if (data.id !== undefined) {
        if (data.trips.length > 0) {
          this.updatePlan(data)
        // } else if (!data.payment || !['paid', 'completed'].includes(data.payment.status)) {
        //   this.updatePlan(data)
        } else {
          this.updatePlan(data, this.getDestinations)
        }
      } else {
        cookies.remove('redirectTo', { path: '/', domain: config.api.DOMAIN });
        this.props.history.push('/trips')
      }
    })
  }

  joinTrip = () => {
    fetch(API + `/travel_plans/${this.props.travel_plan_id}/join`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${cookies.get('jwt')}`,
      },
      dataType: 'json',
    })
    .then(response => response.json())
    .then(data => {
      this.updatePlan(data, this.getDestinations)
    })
  }

  payForTrip = () => {
    this.setState({isSubmitting: true})

    fetch(API + `/travel_plans/${this.props.travel_plan_id}/pay`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${cookies.get('jwt')}`,
      },
      dataType: 'json',
    })
    .then(response => response.json())
    .then(data => {
      if (data && data.redirect_to) {
        window.location.replace(data.redirect_to);
        return null;
      }
    })
  }

  refundForTrip = () => {
    this.setState({isSubmitting: true})

    fetch(API + `/travel_plans/${this.props.travel_plan_id}/refund`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${cookies.get('jwt')}`,
      },
      dataType: 'json',
    })
    .then(response => response.json())
    .then(data => {
      if (data) {
        window.gtag('event', 'refund')
        ReactPixel.track('refund')
        this.setState({is_refunded: data.refunded, isSubmitting: false})
      }
    })
  }

  openSigninModal = () => {
    this.setState({
      signinDialogOpened: true,
    })
  }

  handleSigninChange = (flag, dialogType = 'signup') => {
    this.setState({
      signinDialogOpened: flag,
    })
  }

  handleReloadResults = () => {
    this.setState({
      destination_groups: [],
      isLoading: true,
    }, this.getDestinations)
  }

  handleFiltersChange = (event) => {
    // console.log({ filters: {...this.state.filters, ...event.target.value} })
    let filters = {...this.state.filters, ...event.target.value}

    this.setState({
      filters: filters,
      page: 0,
      destination_groups: [],
      selectedDestinations: [],
    }, this.getDestinations);

    // update filters count
    let count = 0
    let defaults = this.state.filterDefaults

    Object.keys(filters).forEach(function(key) {
      if (JSON.stringify(filters[key]) !== JSON.stringify(defaults[key])) {
        count += 1
      }
    });

    this.setState({showFiltersCount: count})
  }

  handleSearch = (search_params = {}) => {
    let { dates, ...rest } = search_params
    let dates_params = {}

    if (Object.keys(dates).length > 0) {
      dates_params = Object.entries(dates).reduce((a,[k,v]) => (v === null ? a : (a[k]=v, a)), {})
    }

    if (Object.keys(dates_params).length > 0) {
      dates_params = {dates: dates_params}
    }

    search_params = {...rest, ...dates_params}

    this.setState({
      search_params: {...this.state.search_params, ...search_params},
      page: 0,
      destination_groups: [],
    }, this.getDestinations)
  }

  handleCheck = (destination_id) => {
    if (this.state.selectedDestinations.includes(destination_id)) {
      this.setState({ selectedDestinations: (this.state.selectedDestinations.filter(function(e) { return e !== destination_id }) || []) })
    } else {
      this.setState({ selectedDestinations: [destination_id] })
    }
  }

  handlePreview = (destination_id) => {
    if (destination_id) {
      this.setState({ openedTripPreview: true, selectedDestinations: [destination_id] })
    }
  }

  handleCreateTrip = () => {
    this.setState({isSubmitting: true})

    fetch(API + `/travel_plans/${this.props.travel_plan_id}`, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${cookies.get('jwt')}`,
      },
      dataType: 'json',
      body: JSON.stringify({
        selected_destinations: this.state.selectedDestinations
      })
    })
    .then(response => response.json())
    .then(data => {
      this.setState({
        isSubmitting: false,
        selectedDestinations: [],
      }, this.updatePlan(data))
    })
  }

  getSelectedDestinations = () => {
    const destinations = this.state.destination_groups.map((group) => { return group.destinations }).flat().filter((destination) => { return this.state.selectedDestinations.includes(destination.id) })
    return destinations
  }

  getDestinations = () => {
    let travel_preference = (this.props.user ? this.props.user.travel_preference : null)
    let { filters, search_params } = this.state
    let { dates, travelers } = search_params
    let location_from = (search_params && search_params.from ? search_params.from[0] : null)
    let location_to = (search_params && search_params.to ? search_params.to[0] : null)

    abortController.abort()
    abortController = new AbortController();
    const signal = abortController.signal

    if ((this.state.is_member || this.state.is_organizer) && this.state.members.length > 0) {
      this.setState({isLoading: true})

      fetch(API + `/travel_plans/${this.props.travel_plan_id}/destinations` +
                  '?page=' + (this.state.page + 1) +

                  (travelers && travelers.adults ? '&adults=' + travelers.adults : '') +
                  (travelers && travelers.children ? '&children=' + travelers.children : '') +
                  (travelers && travelers.infants ? '&infants=' + travelers.infants : '') +

                  (dates && dates.dates_type ? '&dates_type=' + dates.dates_type : '') +
                  (dates && dates.start_date ? '&start_date=' + dates.start_date : '') +
                  (dates && dates.end_date ? '&end_date=' + dates.end_date : '') +
                  (dates && dates.nights ? '&nights=' + dates.nights : '') +

                  (location_to && location_to.location_type === 'country' ? '&country=' + location_to.country : '') +
                  (location_to && location_to.country_code ? '&country_code=' + location_to.country_code : '') +

                  (location_to && !['country', 'state_or_region'].includes(location_to.location_type) && location_to.slug ? '&location_to=' + location_to.slug : '') +
                  (location_to && !['country', 'state_or_region'].includes(location_to.location_type) && location_to.latitude ? '&latitude_to=' + location_to.latitude : '') +
                  (location_to && !['country', 'state_or_region'].includes(location_to.location_type) && location_to.longitude ? '&longitude_to=' + location_to.longitude : '') +

                  (location_from && location_from.slug ? '&location_from=' + location_from.slug : '') +
                  (location_from && location_from.latitude ? '&latitude_from=' + location_from.latitude : '') +
                  (location_from && location_from.longitude ? '&longitude_from=' + location_from.longitude : '') +

                  (filters && filters.budget !== undefined ? '&budget=' + filters.budget : '') +
                  (filters && filters.weather !== undefined ? '&weather=' + filters.weather.join(',') : '') +
                  (filters && filters.things_to_do !== undefined && !filters.things_to_do.includes('all') ? '&things_to_do=' + filters.things_to_do : '') +
                  (filters && filters.saved !== undefined && filters.saved.length > 0 ? '&saved=' + filters.saved.join(',') : '')
                  ,
      {
        headers: {
          'Authorization': `Bearer ${cookies.get('jwt')}`
        },
        signal: signal,
      })
      .then(response => response.json())
      .then(data => {
        let group = data.destination_groups[0]

        if (group) {
          this.setState(prevState => ({
            isLoading: false,
            destination_groups: prevState.page === 0 ? data.destination_groups : [...prevState.destination_groups, ...data.destination_groups],
            hasMore: group.has_next_page,
            page: prevState.page + 1,
          }))
        }
      })
    }
  }

  copyLink = (link) => {
    window.gtag('event', 'share', {link: link});
    navigator.clipboard.writeText(link)
  }

  occasionItem = (name) => {
    return OCCASIONS.filter((o) => o.value === name)[0]
  }

  hasPaymentFailed = () => {
    // return (this.state.members.length > 0 && this.state.assistance !== "self_planning" && !this.state.payment) || (this.state.payment && this.state.payment.status !== 'completed' && this.state.payment.status !== 'paid')
    false
  }

  isRefundable = () => {
    // return (this.state.is_organizer && this.state.payment && (this.state.payment.status === 'completed' || this.state.payment.status === 'paid') && moment() < moment(this.state.payment.created_at).add(7, 'days'))
    false
  }

  isTravelPlanMember = () => {
    return (this.state.is_member || this.state.is_organizer || this.props.user.is_admin || this.state.isLoading)
  }

  render() {
    const link = `${config.env !== 'development' ? 'https://www' + config.api.DOMAIN : 'http://localhost:5200'}/plan/${this.props.travel_plan_id}`
    const { classes, user } = this.props
    const { isMenuOpened, occasion } = this.state
    const menuId = 'menu';

    return (
      <Fragment>
        <Helmet>
          <title>{`Plan a trip`}</title>
        </Helmet>
        <AppTopBar
          hideMenu={true}
          hideBottomMenu={true}
          showBackButton={true}
          hideCurrency={true}
          backButtonPath={'/trips'}
          onLocationChanged={this.props.onLocationChanged}
          onLocationCleared={this.props.onLocationCleared}
          onCurrencyChange={this.handleReloadResults}
          onChange={this.props.onFilterChange}
          onSigninModalChanged={this.handleSigninChange}
          onSignin={this.props.onSignin}
          user={this.props.user}
          address={startCase(this.props.address)}
          tabSelected={this.props.tabSelected || 'explore'}
          openedSigninDialog={this.state.signinDialogOpened}
          signinDialogType={this.state.openedSigninDialogType !== null && this.state.openedSigninDialogType}
        />

        <div className="trip-container">
          <Grid container spacing={2}>

            {/* Plan was refunded */}
            {this.state.is_refunded && <Grid item xs={12} sm={12} md={8} id="top_container" style={{margin: '0px auto'}}>
              <div className={classes.travelStyleContainer} style={{marginBottom: 100, marginTop: 0}}>
                <Alert
                  severity="success"
                  style={{margin: 'auto', textAlign: 'left', borderRadius: 15, fontWeight: 500}}
                >
                  <AlertTitle style={{fontWeight: 700, fontSize: 15}}>Travel plan was refunded</AlertTitle>
                  <div>Expect to receive refund back to your credit card or bank account in few days.</div>
                </Alert>
              </div>
            </Grid>}

            {!this.state.is_refunded && <Fragment>
              {this.props.travel_plan_id && <Grid item xs={12} sm={12} md={8} id="top_container" style={{margin: '0px auto'}}>

                {/* Plan header only for visitors */}
                {!this.isTravelPlanMember() && <div style={{marginTop: 0, minHeight: 60}}>
                  <Grid
                    container
                    alignItems={'center'}
                    justify={'center'}
                    style={{maxWidth: 1130, margin: '0px auto 10px auto', textAlign: 'left'}}
                  >
                    <Paper className={classes.headerPaper} style={{borderBottomLeftRadius: 0, borderBottomRightRadius: 0, borderBottom: '1px solid #f5f5f5',}}>
                      <Grid item xs={12}>
                        <Typography gutterBottom variant="h6" component="h1" className={classes.headerRight}>
                          <AvatarGroup classes={{avatar: classes.avatarSmall, root: classes.avatarGroup}} max={3}>
                            <Avatar key={0} className={classes.avatarSmall}/>
                            <Avatar key={1} className={classes.avatarSmall}/>
                            <Avatar key={2} className={classes.avatarSmall}/>
                            <Avatar key={3} className={classes.avatarSmall}/>
                            <Avatar key={4} className={classes.avatarSmall}/>
                          </AvatarGroup>
                        </Typography>

                        <Typography gutterBottom variant="h6" component="h1" className={classes.headerTitle}>
                          <span style={{maxWidth: '80%', display: 'inline-flex', marginBottom: 10}}>
                          {occasion ? `${occasion === 'other' ? 'Plan a trip' : this.occasionItem(occasion).title}` : `Plan a trip`}
                          </span>
                          <br/>
                          <small className="trip-summary-dates">
                            {this.state.members.length < 1 ?
                              <Skeleton variant="rect" height={15} width={'150px'} className={classes.skeleton} style={{marginTop: 5, borderRadius: 5}}/>
                            :
                              <span>
                                {this.state.search_params.dates && this.state.search_params.dates.label ? this.state.search_params.dates.label : 'Anytime'}
                              </span>
                            }
                          </small>
                        </Typography>
                      </Grid>
                    </Paper>
                  </Grid>
                </div>}

                {/* Payment failed */}
                {this.hasPaymentFailed() && this.isTravelPlanMember() && <div className={classes.travelStyleContainer}>
                  <Alert
                    severity="error"
                    style={{margin: 'auto', textAlign: 'left', borderRadius: 15, fontWeight: 500}}
                    action={
                      <Button disabled={this.state.isSubmitting} variant="contained" color="primary" size="small" disableElevation className={`${classes.buttonBook}`} style={{color: '#fff', margin: '0px 5px 0px 0px', padding: '8px 15px', minWidth: 130}} onClick={this.payForTrip}>
                        {this.state.isSubmitting ?
                          <Fragment>Submitting...</Fragment>
                          :
                          <Fragment>Retry payment</Fragment>
                        }
                      </Button>
                    }
                  >
                    <AlertTitle style={{fontWeight: 700, fontSize: 15}}>Payment failed</AlertTitle>
                    <div>Payment hasn't been completed</div>

                  </Alert>
                </div>}

                {/* Allow visitor to join trip when she is not a member */}
                {!this.isTravelPlanMember() && <Fragment>
                  {/* Join the trip */}
                  <div className={classes.travelStyleContainer}>
                    <Paper elevation={0} className={classes.travelStylePaper}>
                      <Grid container direction="row" alignItems='center' justify="center" spacing={1}>
                        <Grid item xs={12}>
                          <Typography variant="inherit" style={{ paddingBottom: 0, paddingLeft: 5, fontSize: "16px", textAlign: 'left', fontWeight: 700, display: 'block' }}>
                              <div style={{maxWidth: 750}}>
                                <br/>Join fellow travelers<br/><br/>
                                <small style={{fontWeight: 600, fontSize: '87%', color: "", marginBottom: 0}}>
                                  Sign in to Travelities, take a short quiz about your travel style and join this trip. You will start seeing matching destinations that suit to all of you.<br/><br/>
                                </small>
                              </div>

                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          {this.props.user.is_registered ?
                            <Button variant="contained" color="primary" size="small" disableElevation className={`${classes.buttonBookOutlined} ${classes.travelStyleTestBtn}`} onClick={this.joinTrip}>
                              <Icon className={`material-icons-outlined notranslate`} style={{marginRight: 5}}>person_add</Icon> Join the trip
                            </Button>
                          :
                            <Button variant="contained" color="primary" size="small" disableElevation className={`${classes.buttonBookOutlined} ${classes.travelStyleTestBtn}`} onClick={this.openSigninModal}>
                              Sign in
                            </Button>
                          }
                        </Grid>
                      </Grid>
                    </Paper>
                  </div>
                </Fragment>}

                {/* Plan is paid and user is a member */}
                {!this.hasPaymentFailed() && this.isTravelPlanMember() && <Fragment>

                  {/* Show destination discovery layout */}
                  {this.state.status === "discovery" && <Fragment>
                    <div className={`destinations-container ${classes.discoveryContainer}`}>
                      <div >
                        <div className={classes.categoriesContainer}>
                          {this.state.showFilters ? <Fragment>
                            <div className={classes.closeFiltersBtn}>
                              <ButtonFilter name="filters" defaultSelected={[]} selected={this.state.showFilters} buttonIcon="close" buttonIconSelected="close" label={null} multiple={false} onChange={() => this.setState({showFilters: false})}/>
                            </div>
                            <Tabs
                            value={false}
                            variant="scrollable"
                            scrollButtons="off"
                            aria-label="scrollable auto"
                            style={{marginTop: 7}}
                          >
                            <CustomTab key={-1}><ButtonFilter name="saved" defaultSelected={[]} selected={this.state.filters.saved} buttonIcon="favorite_border" buttonIconSelected="favorite" label="Saved" multiple={false} onChange={this.handleFiltersChange.bind(this)}/></CustomTab>
                            {/* <CustomTab key={1}><SliderFilter name="budget" defaultValue={4000} selected={this.state.filters.budget} min={100} max={4000} step={50} prependLabel="" appendLabel="" description="Max. budget: " label="Budget" onChange={this.handleFiltersChange.bind(this)}/></CustomTab> */}
                            <CustomTab key={0}><ListFilter name="things_to_do" defaultSelected={[]} selected={this.state.filters.things_to_do} description="What places are you interested in ?" label="Interest" list={this.props.user && this.props.user.travel_preference ? INTERESTS.concat(THINGS_TO_DO).filter(interest => [].concat(this.props.user.travel_preference.things_to_do).includes(interest.value)) : INTERESTS.concat(THINGS_TO_DO)} onChange={this.handleFiltersChange.bind(this)}/></CustomTab>
                            <CustomTab key={3}><SliderFilter name="weather" defaultValue={[-20, 40]} selected={this.state.filters.weather} min={-20} max={40} step={10} appendLabel=" °C" description="Temperature: " label="Weather" onChange={this.handleFiltersChange.bind(this)}/></CustomTab>
                            <CustomTab key={2}><ListFilter name="distance" defaultSelected={[]} selected={this.state.filters.distance} description="How far do you want to travel ?" label="Distance" list={DISTANCE} onChange={this.handleFiltersChange.bind(this)}/></CustomTab>
                          </Tabs>
                          </Fragment>
                          :
                          <Fragment>
                            <h1 className={classes.title}>
                              <div style={{float: 'right', padding: '2px 0px 0px 0px', marginRight: 0}}>
                                <ButtonFilter name="saved" defaultSelected={[]} selected={this.state.filters.saved} buttonIcon="favorite_border" buttonIconSelected="favorite" label={isWidthDown('sm', this.props.width) ? "" : "Saved"} multiple={false} onChange={this.handleFiltersChange.bind(this)}/>
                                <ButtonFilter name="filters" defaultSelected={[0]} selected={[this.state.showFiltersCount]} buttonIcon="tune" buttonIconSelected="tune" label={this.state.showFiltersCount} multiple={false} onChange={() => this.setState({showFilters: true})}/>
                              </div>

                              {this.state.filters.saved.length !== 0 ? 'Saved' : 'Recommended'}
                              <small className={classes.subtitle} style={{marginBottom: 0, fontSize: 13, margin: '3px 0px 0px 0px'}}>
                              {this.state.filters.saved.length !== 0 ? 'Shortlisted by any traveler' : 'Based on travelers\' style'}
                              </small>
                            </h1>
                          </Fragment>}
                        </div>
                      </div>

                      {(this.state.destination_groups.length < 1 && !this.state.isLoading) && <Grid item xs={12} className={classes.showcaseDestinations}>
                        <Typography gutterBottom variant="inherit" style={{ paddingBottom: 0, fontSize: "100%", textAlign: 'center', fontWeight: 400, display: 'block' }}>
                          <h2 className={classes.showcaseHeadline}>
                            <Typography className={classes.showcaseHeadline}>No results</Typography>
                            <small className={classes.showcaseSubtitle} style={{fontSize: "80%"}}>Change some filters or clear them all</small>

                            <Button variant="contained" color="primary" size="small" disableElevation className={`${classes.buttonBook}`} style={{float: 'inherit', marginTop: '20px', marginLeft: 0, boxShadow: 'none'}} onClick={this.clearFilters}>
                              Clear all
                            </Button>
                          </h2>
                        </Typography>
                      </Grid>}

                      <InfiniteScroll
                        dataLength={this.state.destination_groups.length} //This is important field to render the next data
                        next={this.getDestinations}
                        hasMore={this.state.hasMore}
                        // hasMore={(this.props.interests || 'all') === 'all' || this.props.interests === 'discover-weekly' || this.props.interests === 'saved' ? this.state.hasMore : false}
                        loader={<div className={classes.buttonLoading}>Loading...</div>}
                        style={{display: 'contents'}}
                        scrollThreshold={0.4}
                      >
                        <Grid container spacing={2} className={classes.gridFilters}>
                          {((this.state.isLoading && this.state.destination_groups.length === 0) ? Array.from(new Array(1)) : this.state.destination_groups).map((group, i) => {
                            return <DestinationList key={group ? `${group.key}-${i}` : 'loading'}
                                    search_params={this.state.search_params}
                                    next_page_url={group && API + group.next_page_url}
                                    destinations={group && group.destinations}
                                    title={group && group.title}
                                    description={group && group.description}
                                    has_next_page={false}
                                    link_to_all={group && group.link_to_all}
                                    page={group && group.page}
                                    pageSize={3}
                                    group_name={group && group.key}
                                    members={this.state.members}
                                    member_id={this.state.member_id}
                                    showHeader={false}
                                    isLoading={this.state.isLoading}
                                    onSelected={this.props.onSearch}
                                    onChecked={this.handleCheck}
                                    onPreview={this.handlePreview}
                                    address={this.props.address}
                                    addressType={this.props.addressType}
                                    countryCode={this.props.countryCode}
                                    locationFrom={(this.state.from_address ? this.state.from_address : 'nearby')}
                                    infiniteScroll={false}
                                    travel_plan_id={this.props.travel_plan_id}
                                    checked_destinations={this.state.selectedDestinations}
                                  />
                          })}
                        </Grid>
                      </InfiniteScroll>
                    </div>

                    {/* Bottom navigation to create trip */}
                    <Box display={{ xs: 'block', md: 'block' }}>
                      <Paper className={classes.bottomPaper} elevation={0}>
                        <Grid container style={{maxWidth: 1130, margin: 'auto'}}>
                          <Grid item xs={12} md={8} className={classes.header} style={{margin: 'auto'}}>
                            <Button disabled={this.state.selectedDestinations.length < 1 || this.state.isSubmitting} variant="contained" color="primary" size="large" className={classes.bottomButtonPlan} onClick={this.handleCreateTrip}>
                              {this.state.isSubmitting ?
                                <Fragment>Creating...</Fragment>
                                :
                                <Fragment>Create trip</Fragment>
                              }
                            </Button>
                            {this.state.selectedDestinations.length < 1 ?
                              <Typography className={classes.bottomSection} style={{fontSize: 14, fontWeight: 500, border: 'none', padding: '10px'}}>
                                No destination selected
                                <br/>
                                <small style={{fontWeight: 500, color: '#828282', fontSize: 13, marginTop: 4, display: 'block'}}>
                                  Choose from recommendations
                                </small>
                              </Typography>
                            :
                              <Typography className={classes.bottomSection} style={{fontSize: 14, fontWeight: 700, border: 'none', padding: '10px'}}>
                                {this.getSelectedDestinations()[0] && this.getSelectedDestinations()[0].images.length > 0 && <CardMedia
                                  component="img"
                                  image={this.getSelectedDestinations()[0].images[0].sizes.medium.url}
                                  style={{display: 'inline-block', width: 50, height: 50, borderRadius: 15, float: 'left', marginRight: 10, marginTop: -4}}
                                />}
                                {this.getSelectedDestinations()[0].name}
                                <br/>
                                <small style={{fontWeight: 500, color: '#828282', fontSize: 13, marginTop: 4, display: 'block'}}>
                                {this.getSelectedDestinations()[0].travel.description}
                                </small>
                              </Typography>
                            }
                          </Grid>
                        </Grid>
                      </Paper>
                    </Box>
                  </Fragment>}

                  {/* Show trip layout */}
                  {["planning", "planned", "booked"].includes(this.state.status) && <div style={{marginTop: 0}}>
                    {this.state.trips.length > 0 &&
                      <Fragment>
                        <TripItinerary
                          travel_plan_id={this.props.travel_plan_id}
                          trip_id={this.state.trips[0].id}
                          plan={this.state.plan}
                          planned={this.state.trips[0].planned}
                          user={this.props.user}
                          sharableLink={`/plan/${this.props.travel_plan_id}`}
                        />

                        {this.isRefundable() && this.state.trips[0].planned && <div className={classes.travelStyleContainer} style={{marginBottom: 100, marginTop: -20}}>
                          <Alert
                            severity="success"
                            style={{margin: 'auto', textAlign: 'left', borderRadius: 15, fontWeight: 500}}
                            action={
                              <Button disabled={this.state.isSubmitting} variant="outlined" color="primary" size="small" disableElevation className={`${classes.buttonBookOutlined}`} style={{margin: '0px 5px 0px 0px', padding: '8px 15px', minWidth: 100}} onClick={this.refundForTrip}>
                                {this.state.isSubmitting ?
                                  <Fragment>Submitting...</Fragment>
                                  :
                                  <Fragment>Refund</Fragment>
                                }
                              </Button>
                            }
                          >
                            <AlertTitle style={{fontWeight: 700, fontSize: 15}}>7-day money back guarantee </AlertTitle>
                            <div>Not happy with the guide? Get refund for this travel guide.</div>
                          </Alert>
                        </div>}
                      </Fragment>
                    }
                  </div>}

                </Fragment>}

              </Grid>}
            </Fragment>}
          </Grid>
        </div>

        <Menu
          anchorEl={this.state.anchorEl}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          id={menuId}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={isMenuOpened}
          onClose={this.handleMenuClose}
          classes={{paper: classes.menuPaper}}
        >
          <MenuItem disabled={(this.state.members && this.state.members.length < 1) || (this.state.is_organizer && this.state.members.length > 1)} onClick={this.handleLeaveTrip}>
            <ListItemText primary={'Leave the trip'} classes={{primary: classes.listItemText, secondary: classes.listItemTextSecondary}} />
          </MenuItem>
        </Menu>

      </Fragment>
    )
  }
}

const styles = theme => ({
  h3: {
    fontWeight: 800,
    fontSize: 20,
    margin: '30px 0px 10px 0px',
  },
  headlinePaper: {
    padding: '0px 0px 40px 0px',
    margin: '-100px auto',
    color: '#333',
    // textAlign: 'left',
    width: '100%',
    position: 'relative',
    boxShadow: 'none',
    height: '100%',
    // minHeight: '60vh',
    paddingBottom: '96px',
    backgroundColor: 'transparent',
    // background: 'linear-gradient(180deg, rgb(26 83 53 / 9%) 0%, rgb(205 214 208 / 77%) 100%)',

    [theme.breakpoints.down('sm')]: {
      paddingBottom: 4,
    },
  },
  headline: {
    maxWidth: 1119,
    // width: '100%',
    display: 'block',
    position: 'relative',
    margin: '0px auto',
    fontSize: 28,
    fontWeight: 400,
    textAlign: 'left',
    marginTop: '30px',
    padding: '120px 20px 50px 20px',

    [theme.breakpoints.down('xs')]: {
      fontSize: 25,
      padding: '99px 20px 10px 20px',
    },
  },
  closeFiltersBtn: {
    float: 'right',
    padding: '7px 0px 0px 7px',
    // marginRight: 10,

    [theme.breakpoints.down('sm')]: {
      float: 'right',
      padding: '7px 0px 0px 7px',
      marginRight: 0,
    },
  },
  title: {
    maxWidth: 1119,
    // width: '100%',
    display: 'block',
    position: 'relative',
    margin: '0px auto',
    fontSize: 17,
    fontWeight: 700,
    textAlign: 'left',
    marginTop: 5,
    padding: '0px 0px 0px 0px',

    [theme.breakpoints.down('sm')]: {
      marginTop: '0px',
      padding: '5px 0px 0px 0px',
      fontSize: 17,
    },

    [theme.breakpoints.down('xs')]: {
      marginTop: 0,
      padding: '5px 0px 0px 0px',
      fontSize: 17,
    },
  },
  subtitle: {
    fontWeight: 500,
    fontSize: '50%',
    color: '#828282',
    display: 'block',
    marginTop: 14,
  },
  gridSearch: {
    textAlign: 'left',
    maxWidth: 1130,
    margin: '80px auto 0px auto',
    zIndex: 98,
    position: 'relative',

    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },

    [theme.breakpoints.down('sm')]: {
      margin: '80px 10px 0px 10px',
    },

    [theme.breakpoints.down('xs')]: {
      margin: '60px 10px 0px 10px !important',
    },
  },
  gridFilters: {
    textAlign: 'left',
    maxWidth: 1142,
    margin: '60px auto 0px auto',
    width: 'calc(100% - 0px)',
    overflow: 'hidden',

    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  icon: {
    fontSize: 21,
    fontWeight: 600,
    marginTop: 0,
    marginRight: 0,
    marginLeft: -5,
    padding: '8px !important',
    verticalAlign: 'middle',
    color: '#02c39a',
  },
  buttonAddMemberSmall: {
    height: 32,
    fontSize: '13px',
    fontWeight: 900,
    backgroundColor: '#fff',
    color: '#02c39a',
    border: '2px solid #02c39a',
    borderRadius: 45,
    padding: '18px 10px',
    minWidth: 10,
    verticalAlign: 'super',

    [theme.breakpoints.down('xs')]: {
      padding: '18px 6px',
    },

    '&:hover': {
      color: '#fff',
      backgroundColor: '#02c39a',
      border: '2px solid #02c39a',
    }
  },
  buttonBookOutlined: {
    color: '#02c39a',
    margin: '10px -6px 10px 10px',
    border: '2px solid #02c39a',
    textTransform: 'none',
    borderRadius: 45,
    fontWeight: 800,
    // boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
    padding: '13px 30px',
    // minWidth: 155,

    '&:hover': {
      border: '2px solid transparent',
      boxShadow: 'none',
    }
  },
  buttonBook: {
    // float: 'right',
    color: '#fff',
    margin: '10px -6px 10px 10px',
    backgroundColor: '#02c39a',
    textTransform: 'none',
    // boxShadow: 'none',
    borderRadius: 45,
    fontWeight: 800,
    boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
    padding: '13px 30px',

    '&:hover': {
      backgroundColor: 'rgb(1, 136, 107)',
      boxShadow: 'none',
    }
  },
  categoriesContainer: {
    // width: '102%',
    margin: '30px auto -50px auto',
    maxWidth: 1137,
    paddingRight: 0,
    paddingLeft: 10,
    top: -1,
    whiteSpace: 'nowrap',
    overflowX: 'auto',

    position: 'sticky',
    backgroundColor: '#fff',
    zIndex: 99,
    paddingTop: 10,
    // boxShadow: '0 10px 20px -22px rgb(0 0 0 / 52%)',

    [theme.breakpoints.down('md')]: {
      width: 'calc(100% - 10px)',
    },
  },
  travelStyleContainer: {
    maxWidth: 1119,
    // width: '100%',
    display: 'block',
    position: 'relative',
    margin: '10px auto 20px auto',
    fontSize: 28,
    fontWeight: 400,
    textAlign: 'left',
    marginTop: '20px',
    padding: '0px 10px',

    [theme.breakpoints.down('xs')]: {
      padding: '0px 5px',
    },
  },
  travelStylePaper: {
    border: '1px solid #e5e5e5',
    padding: '20px',
    marginTop: 0,
    marginBottom: 0,
    backgroundImage: 'url(/discover-weekly-background.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'inherit',
    backgroundPosition: '-1px -2px',
    boxShadow: '0 0px 10px 0 rgb(0 0 0 / 5%)',

    [theme.breakpoints.down('xs')]: {
      backgroundPosition: '-3px -2px',
      margin: '20px auto 0px auto',
      padding: '15px 10px 10px',
    },
  },
  travelStyleIcon: {
    verticalAlign: 'middle',
    float: 'left',
    padding: '14px',
    margin: '0px 20px 0px 10px',
    backgroundColor: '#fff',
    color: '#02c39a',
    borderRadius: 25,
    display: 'block',

    ["@media (max-width:704px)"]: {
      display: 'none !important',
    },

    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  travelStyleTestBtn: {
    margin: '0px 10px 0px 0px !important',
    float: 'left',
    color: '#fff',
    boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',

    [theme.breakpoints.down('xs')]: {
      margin: '10px auto 0px auto !important',
      float: 'left',
    },
  },
  avatarSmall: {
    width: 36,
    height: 36,
    fontSize: '15px',
    fontWeight: 800,
    backgroundColor: '#fff',
    color: '#02c39a',
    borderColor: '#02c39a',
  },
  avatarGroup: {
    float: 'left',
    marginRight: 5,
  },
  showcaseDestinations: {
    margin: '100px 0px 40px 0px',

    [theme.breakpoints.down('xs')]: {
      margin: '100px 0px 30px 0px',
    },
  },
  showcaseHeadline: {
    fontSize: '30px',
    fontWeight: 800,
    color: '#000',
    textDecoration: 'none',

    [theme.breakpoints.down('xs')]: {
      fontSize: '25px',
      marginBottom: -5,
    },
  },
  showcaseSubtitle: {
    fontWeight: 600,
    fontSize: '50% !important',
    // fontSize: '12px',
    color: '#828282',
    display: 'block',
    marginTop: 12,
  },
  buttonLoading: {
    color: '#02c39a',
    textDecoration: 'none',
    margin: '27px auto',
    display: 'block',
    position: 'relative',
    fontSize: '15px',
    fontWeight: 600,
    padding: '13px 20px 13px 27px',
    backgroundColor: 'transparent',
    borderRadius: 50,
    border: '2px solid #02c39a',
    width: 65,
  },
  shareCodeField: {
    marginBottom: 10,
    marginLeft: -5,
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: 15,

    '& .MuiOutlinedInput-root': {
      fontSize: 14,
      fontWeight: 500,

      '& fieldset': {
        borderRadius: 15,
      },
    },
  },
  shareButtonBook: {
    // float: 'right',
    color: '#fff',
    margin: '10px -6px 10px 10px',
    backgroundColor: '#02c39a',
    textTransform: 'none',
    boxShadow: 'none',
    borderRadius: 25,
    fontWeight: 800,

    '&:hover': {
      backgroundColor: 'rgb(1, 136, 107)',
      boxShadow: 'none',
    }
  },
  closeButton: {
    float: 'right',
  },
  menuBox: {
    float: 'right',
    // border: '1px solid #ddd',
    marginRight: 0,
    marginLeft: 5,
    padding: 10,
  },
  menuIcon: {
    fontSize: 20,
    color: '#999',
  },
  menuPaper: {
    margin: '10px 0px',
    boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
    border: '1px solid #f2f2f2',
  },
  listItemText: {
    fontSize: 14,
    fontWeight: 600,
  },
  listItemTextSecondary: {
    fontSize: 11,
    fontWeight: 500,
    color: '#999',
  },
  shadowOnScroll: {
    height: 89,
    position: 'sticky',
    top: -14,
    zIndex: 100,
    marginTop: 10,
    marginBottom: -40,
    marginLeft: -7,
    '-webkit-backface-visibility': 'hidden',

    "&::before": {
      content: '""',
      display: 'block',
      height: 39,
      position: 'sticky',
      '-webkit-position': 'sticky',
      top: 11,
      boxShadow: '5px 22px 5px rgba(0,0,0,0.5)',
    },

    "&::after": {
      content: '""',
      display: 'block',
      height: 39,
      position: 'sticky',
      "-webkit-position": 'sticky',
      background: 'linear-gradient(white 10%, rgba(255,255,255,0.8) 50%, rgba(255,255,255,0.4) 70%, transparent)',
      top: 0,
      zIndex: 2,
    },

    "& > div": {
      height: 63,
      padding: '5px 5px 5px 10px',
      position: 'sticky',
      "-webkit-position": 'sticky',
      top: -1,
      marginTop: -26,
      zIndex: 3,
    },
  },
  headerPaper: {
    width: '100%',
    // border: ' 1px solid #eee',
    marginBottom: -14,
    // boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    // boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
    boxShadow: 'none',
    position: 'relative',

    [theme.breakpoints.down('sm')]: {
      padding: '15px 15px 0px 15px',
      margin: '-20px -10px 40px -10px',
    },
  },
  headerTitle: {
    marginLeft: 0,
    marginBottom: 0,
    lineHeight: '20px',
    padding: '10px 0px 10px 10px',
    fontWeight: 900,
    minHeight: 28,
  },
  headerRight: {
    lineHeight: '20px',
    padding: '10px',
    float: 'right',
    textAlign: 'right',
    fontWeight: 800,
    right: 0,
    position: 'relative',

    [theme.breakpoints.down('xs')]: {
      right: -10,
    },
  },
  bottomPaper: {
    // boxShadow: 'none',
    textAlign: 'left',
    borderTop: '1px solid #eee',
    borderRadius: 0,
    margin: 0,
    fontSize: 16,
    width: '100vw',
    position: 'fixed',
    bottom: 0,
    left: 0,
    display: 'block',
    zIndex: 99,
    boxShadow: '0 -0.5px 11px 0 rgba(0, 0, 0, 0.08)',
  },
  bottomPaperIcon: {
    margin: '0px 0px 0px 7px',
    padding: 0,
    verticalAlign: 'top',
    fontSize: 15,
    // borderBottom: '1px solid #000',
  },
  bottomSection: {
    fontSize: 18.5,
    fontWeight: 700,
    lineHeight: '18px',
    padding: '20px 20px',
    // margin: '12px 0px',
    // borderBottom: '1px solid #f2f2f2',

    '& small': {
      color: '#999',
      fontSize: '80%',
    }
  },
  bottomButtonPlan: {
    float: 'right',
    color: '#fff',
    margin: '10px 10px 10px 5px',
    backgroundColor: '#02c39a',
    textTransform: 'none',
    boxShadow: 'none',
    borderRadius: 25,
    fontWeight: 700,

    '&:hover': {
      backgroundColor: 'rgb(1, 136, 107)',
      boxShadow: 'none',
    }
  },
  discoveryContainer: {
    overflow: 'hidden',
    marginBottom: 70,

    [theme.breakpoints.down('sm')]: {
      marginTop: -80,
    },
  }
})

export default withRouter(withStyles(styles)(withWidth()(Plan)))
